import React from 'react';
import './Loader.css';

function Loader() {
  return (
    <div className="loader-container">
      <div className="loader-wrapper">
       <img className='loder-svg' src='./Pics/loader.gif' />
      </div>
    </div>
  );
}

export default Loader;
